import { useCallback, useState } from "react";
import { toastr } from "react-redux-toastr";
import { client, getApiErrorMessage } from "utils/api";

const MassEventsTrigger = ({
  mass_events,
  setMassEvents,
  refetch,
  refetchStatuses,
}) => {
  const [is_loading, setLoading] = useState(false);

  const handleTrigger = useCallback(async () => {
    try {
      setLoading(true);
      for (const element of mass_events) {
        try {
          if (element.action === "start_workflows") {
            await client.post(`/channel_product_workflows/start_workflows`, {
              type: element.type,
              id: element.id,
            });
          }
          if (element.action === "trigger_event") {
            await client.post(`/channel_product_workflows/trigger_event`, {
              event: element.event,
              type: element.type,
              id: element.id,
            });
          }
        } catch (error) {
          toastr.error("Błąd", getApiErrorMessage(error));
        }
      }
      setMassEvents([]);
      refetch();
      refetchStatuses();
    } finally {
      setLoading(false);
    }
  }, [mass_events, refetch, setMassEvents, refetchStatuses, setLoading]);

  return (
    <button
      type="button"
      className="btn btn-sm btn-blue btn-mass-event"
      disabled={is_loading || !mass_events?.length}
      onClick={handleTrigger}
    >
      {is_loading ? (
        <span>Proszę czekać trwa aktualizacja...</span>
      ) : (
        <span>Aktualizuj ({mass_events?.length})</span>
      )}
    </button>
  );
};

export default MassEventsTrigger;
